import InfoIcon from 'assets/icons/landing/info.svg?component'
import BodyText from 'components/UI/Landing/body-text'
import SubTitle from 'components/UI/Landing/subtitle'
import PrimaryText from 'components/UI/Landing/text-primary'
import { ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'
import { gradiendBorderStyles } from 'utils/constants'

type TermsCardProps = {
  icon: string | ReactNode
  subtitle: string
  subtitle2?: string | null
  primaryText: string
  primaryText2?: string | null
  twStyle?: TwStyle | Array<TwStyle>
  note?: string | null
}

export default function TermsCard({
  icon,
  subtitle,
  subtitle2,
  primaryText2,
  primaryText,
  note,
  twStyle
}: TermsCardProps) {
  if (note) {
    return (
      <div
        css={[
          tw`flex flex-col rounded-[20px] p-4 md:p-6 bg-[var(--bg-landing-card)] gap-y-4 relative shadow-sm`,
          twStyle,
          gradiendBorderStyles
        ]}
      >
        <div css={[tw`flex items-center lg:flex-col lg:items-start`]}>
          <div tw='flex-shrink-0'>{icon}</div>
          <div className='mt-0 lg:mt-4 space-y-4'>
            <div>
              <SubTitle title={subtitle} className='text-sm mb-1 sm:mb-2' />
              <PrimaryText
                text={primaryText}
                className='text-[18px] sm:text-[20px] leading-[140%] text-[var(--text-landing-green)]'
              />
            </div>
            {(subtitle2 || primaryText2) && (
              <div>
                {subtitle2 && <SubTitle title={subtitle2} className='text-sm mb-1 sm:mb-2' />}
                {primaryText2 && (
                  <PrimaryText
                    text={primaryText2}
                    className='text-[18px] sm:text-[20px] leading-[140%] text-[var(--text-landing-green)]'
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className='flex items-center gap-3 bg-[var(--bg-landing-warning)] p-3 rounded-lg text-muted mt-3 lg:mt-auto lg:flex-col lg:items-start'>
          <div className='shrink-0'>
            <InfoIcon />
          </div>
          <BodyText text={note} className='text-[12px] leading-[140%]' />
        </div>
      </div>
    )
  }

  return (
    <div
      css={[
        tw`rounded-[20px] p-4 bg-[var(--bg-landing-card)] flex relative
           lg:flex-col items-center lg:items-start gap-x-3 gap-y-4 shadow-sm md:p-6`,
        twStyle,
        gradiendBorderStyles
      ]}
    >
      <div tw='flex-shrink-0'>{icon}</div>
      <div className='lg:mt-auto space-y-4'>
        <div>
          <SubTitle title={subtitle} className='text-sm mb-1 sm:mb-2' />
          <PrimaryText
            text={primaryText}
            className='text-[18px] sm:text-[20px] leading-[140%] text-[var(--text-landing-green)]'
          />
        </div>
        {(subtitle2 || primaryText2) && (
          <div>
            {subtitle2 && <SubTitle title={subtitle2} className='text-sm mb-1 sm:mb-2' />}
            {primaryText2 && (
              <PrimaryText
                text={primaryText2}
                className='text-[18px] sm:text-[20px] leading-[140%] text-[var(--text-landing-green)]'
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}
